<template>
    <div name="use20240314">
        솔닥 주식회사는 비대면 진료 서비스 제공을 위하여 아래와 같이 개인정보를 수집ᆞ이용하고, 제3자에게 제공합니다.<br/><br/>

- <strong>개인정보 수집ᆞ이용</strong><br/><br/>

<table border="1">
  <tr>
    <th>수집ᆞ이용 목적</th>
    <th>항목</th>
    <th>보유ᆞ이용기간</th>
  </tr>
  <tr>
    <td rowspan="3">회원 가입 및 관리</td>
    <td>- 일반회원: 이름, 아이디, 비밀번호, 이메일, 휴대전화번호, 생년월일, 카카오톡 ID, 회원 탈퇴 사유, 암호화된 동일인 식별정보(CI), 중복가입 확인정보(DI)</td>
    <td rowspan="15">개인정보 처리방침에 따라 이용자의 이용계약 해지(회원 탈퇴) 시까지</td>
  </tr>
  <tr>
    <td>- 제휴 의사/약사 회원: 이름, 생년월일, 사진, 이메일, 휴대폰 번호, 면허번호, 근무처 정보(병원/약국명, 주소, 연락처), 결제정보(계좌정보, 진료비용, 조제비), 학력, 경력, 진료과목, 배달가능과목, 전문분야, 요양기관번호, 사업자등록번호, 암호화된 동일인 식별정보(CI), 중복가입 확인정보(DI)</td>
  </tr>
  <tr>
    <td>- 만 14세 미만 아동 확인: 법정 생년월일</td>
  </tr>
  <tr>
    <td>비대면 진료 예약 및 알림</td>
    <td>카카오톡 ID, 휴대폰 번호, 이름, 주소, 생년월일, 이메일, 초·재진여부, 진료시간(원격진료 가능한 날짜·시간), 진료과목, 진료신청서, 선호의약품, 화상진료 영상, 처방전 및 처방정보</td>
  </tr>
  <tr>
    <td>비대면 진료</td>
    <td>이름, 생년월일, 성별, 휴대폰번호, 진료과목, 선호의약품, 진료시간, 진료신청서, 증상내용, 진료 예약일시, 진료 취소</td>
  </tr>
  <tr>
    <td>비대면 진료ᆞ처방 내역 관리</td>
    <td>진료과목, 선호의약품, 진료시간, 진료신청서, 증상내용, 진료 예약 일시, 진료 취소 내역, 진료 내역, 처방 정보</td>
  </tr>
  <tr>
    <td>비대면 진료ᆞ온라인 처방을 위한 전달용 자료 수집, 재진 알림 발송</td>
    <td>처방날짜, 처방전 교부 번호, 진료과목, 질병코드, 조제약, 복약 안내사항(투약량, 횟수, 일수)</td>
  </tr>
  <tr>
    <td>결제 카드 등록</td>
    <td>카드사, 카드종류, 카드번호, 카드비밀번호 앞 2자리, 유효기간, 생년월일, 이름</td>
  </tr>
  <tr>
    <td>계좌이체 이용 결제 수단 제공</td>
    <td>계좌번호, 예금주, 은행명</td>
  </tr>
  <tr>
    <td>배송 서비스</td>
    <td>수령인 이름, 휴대폰 번호, 배송 주소</td>
  </tr>
  <tr>
    <td>서비스 이용 관련 민원상담, 고충처리</td>
    <td>서비스 이용 기록, 접속로그, 접속 IP 정보, 의사 정보, 진료과목, 전문분야, 진료예약 내역, 상담 내역, 이메일, 휴대폰 번호</td>
  </tr>
  <tr>
    <td>서비스 후기 수집</td>
    <td>사용후기</td>
  </tr>
  <tr>
    <td>서비스 개선</td>
    <td>접속 기기 정보, 접속 로그, IP 주소, 쿠키, 기기고유번호, 방문일시, 불량 이용 기록, 사용 이동통신사, 광고식별자</td>
  </tr>
</table>

※ 위의 개인정보 수집ᆞ이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우, 솔닥 비대면 진료 서비스 이용에 제한을 받을 수 있습니다.<br/><br/>

- <strong>민감정보 수집ᆞ이용</strong><br/><br/>

<table border="1">
  <tr>
    <th>수집ᆞ이용 목적</th>
    <th>항목</th>
    <th>보유ᆞ이용기간</th>
  </tr>
  <tr>
    <td>진료를 위한 사전 건강 문진 정보</td>
    <td>성별, 신장, 체중, 알러지 정보, 임신 여부, 혈액형, 흡연, 음주, 활동량, 증상에 대한 설명, 증상 사진, 기존 복약 정보, 과거 병력, 기저질환, 수술 여부, 입원 여부, 부상 여부, 가족력</td>
    <td rowspan="2">개인정보 처리방침에 따라 이용자의 이용계약 해지(회원 탈퇴) 시까지. 단, 관련 법령에 따라 별도 보관되는 정보의 경우 해당 법령에 정한 기간까지</td>
  </tr>
  <tr>
    <td>비대면 진료ᆞ예약ᆞ처방ᆞ약 배송 서비스 관리</td>
    <td>진료병원, 진료과목, 진료의사, 진료일시, 진료기록, 증상 정보, 진료를 위한 사전 건강 문진 정보 입력 내용, 진료 영상, 처방전, 복약지도정보</td>
  </tr>
</table>

※ 위의 민감정보 수집ᆞ이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우, 솔닥 비대면 진료 서비스 이용에 제한을 받을 수 있습니다.<br/><br/>

- <strong>[필수]개인정보 제3자 제공</strong><br/><br/>

<table border="1">
  <tr>
    <th>제공받는자</th>
    <th>제공 목적</th>
    <th>제공 내용</th>
    <th>보유ᆞ이용기간</th>
  </tr>
  <tr>
    <td>솔닥 제휴 의료진</td>
    <td>비대면 진료 서비스 제공 (진료예약, 취소, 진료내역 확인 및 관리, 처방 문의 및 상담)</td>
    <td>이름, 생년월일, 성별, 휴대폰 번호, 환자 문진 정보, 증상 정보, 증상 관련된 첨부 사진 정보, 환자의 과거 진료내역, 진료 영상 기록</td>
    <td rowspan="3">개인정보 처리방침에 따라 이용자의 이용계약 해지(회원 탈퇴) 시까지. 단, 관련 법령에 따라 별도 보관되는 정보의 경우 해당 법령에 정한 기간까지</td>
  </tr>
  <tr>
    <td>솔닥 제휴 약국</td>
    <td>약 배송 서비스 제공 (처방전 확인 및 조제, 배송, 대리수령, 복약지도, 문의 및 상담)</td>
    <td>이름, 생년월일, 성별, 휴대폰 번호, 처방전, 배송 주소, 보호자 이름, 복지시설 직원 이름, 환자와의 관계 정보</td>
  </tr>
  <tr>
    <td>솔닥 제휴 기관(노인·장애인복지시설)</td>
    <td>비대면 진료 서비스 이용 보조, 약 배송 서비스 보조, 복약지도</td>
    <td>이름, 생년월일, 성별, 휴대폰 번호, 증상 정보, 의사 이름, 약사 이름, 처방전 중 복약지도 관련 항목</td>
  </tr>
</table>

※ 위의 개인정보 제공에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우, 솔닥 비대면 진료 서비스 이용에 제한을 받을 수 있습니다.<br/><br/>

- <strong>[선택] 마케팅 목적 개인정보 제3자 제공 및 광고성 정보 수신 동의</strong><br/><br/>

<table border="1">
  <tr>
    <th>제공받는자</th>
    <th>제공 목적</th>
    <th>제공 내용</th>
    <th>보유ᆞ이용기간</th>
  </tr>
  <tr>
    <td>솔닥 제휴 의료진</td>
    <td>마케팅</td>
    <td>이름, 생년월일, 성별, 휴대폰 번호</td>
    <td>개인정보 처리방침에 따라 이용자의 이용계약 해지(회원 탈퇴) 시까지. 단, 관련 법령에 따라 별도 보관되는 정보의 경우 해당 법령에 정한 기간까지</td>
  </tr>
</table>

※ 위의 개인정보 제공에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우, 솔닥 비대면 진료 서비스 이용에 제한을 받을 수 있습니다.<br/><br/>

    </div>
</template>

<script>
export default {
    name: 'use20240314'
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/pages/barocare/contents/use/20240314.vue